import { Product as IProduct } from "../../../api/commercial/generated-types";
import { useFormatNumber } from "../../shared/hooks/useFormatNumber";

type UseTurnoverBonusSpendingType = {
  lowSpending: string;
  highSpending: string;
};

export default function useTurnoverBonusSpending(
  feature: IProduct["features"][0],
): UseTurnoverBonusSpendingType {
  const { formatNumberAsAmount } = useFormatNumber();

  let lowSpending = null;
  let highSpending = null;

  switch (feature) {
    case "TURNOVER_BONUS_LOW":
      lowSpending = 7500;
      highSpending = 15000;
      break;

    case "TURNOVER_BONUS_HIGH":
      lowSpending = 10000;
      highSpending = 20000;
      break;
  }

  return {
    lowSpending: formatNumberAsAmount(lowSpending, { withCurrency: false }),
    highSpending: formatNumberAsAmount(highSpending, { withCurrency: false }),
  };
}
